module.exports = __webpack_public_path__ + "static/media/selling_price.6d19014c.svg";